import { render, staticRenderFns } from "./Sensors.vue?vue&type=template&id=c0bafab6&scoped=true&"
import script from "./Sensors.vue?vue&type=script&lang=js&"
export * from "./Sensors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bafab6",
  null
  
)

export default component.exports